// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* ----------------------------------------------
* Demo styles
* ----------------------------------------------
**/
.u-position-absolute {
    position: absolute;
}

.u-position-relative {
    position: relative;
}

.accordion {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
}

.accordion__item + .accordion__item {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.accordion__item--has-icon {
    position: relative;
}

.accordion__title {
    background-color: #eee;
    color: #444;
    cursor: pointer;
    padding: 18px;
    width: 100%;
    text-align: left;
    border: none;
}

    .accordion__title:hover {
        background-color: #ddd;
    }

.accordion__body {
    padding: 20px;
    display: block;
    animation: fadein 0.35s ease-in;
}

.accordion__body--hidden {
    display: none;
    opacity: 0;
    animation: fadein 0.35s ease-in;
}

.accordion__title > *:last-child,
.accordion__body > *:last-child {
    margin-bottom: 0;
}

.accordion__arrow {
    display: inline-block;
    position: relative;
    width: 24px;
    height: 12px;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -6px;
}

.accordion__arrow::after,
.accordion__arrow::before {
    display: block;
    position: absolute;
    top: 50%;
    width: 10px;
    height: 2px;
    background-color: currentColor;
    content: '';
}

.accordion__arrow::before {
    left: 4px;
    transform: rotate(45deg);
}

[aria-expanded='true'] .accordion__arrow::before, [aria-selected='true'] .accordion__arrow::before {
    transform: rotate(-45deg);
}

.accordion__arrow::after {
    right: 4px;
    transform: rotate(-45deg);
}

[aria-expanded='true'] .accordion__arrow::after, [aria-selected='true'] .accordion__arrow::after {
    transform: rotate(45deg);
}

.accordion__arrow::before,
.accordion__arrow::after {
    transition: transform 0.25s ease, -webkit-transform 0.25s ease;
}

/* -------------------------------------------------- */
/* ---------------- Animation part ------------------ */
/* -------------------------------------------------- */

@keyframes fadein {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes move-down {
    0% {
        transform: translateY(0);
    }
    10% {
        transform: translateY(0);
    }
    20% {
        transform: translateY(5px);
    }
    30% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes move-up {
    0% {
        transform: translateY(0);
    }
    10% {
        transform: translateY(0);
    }
    20% {
        transform: translateY(-5px);
    }
    30% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(0);
    }
}

.accordion__title--animated:hover .accordion__arrow {
    animation-name: move-down;
    animation-duration: 1.5s;
}

.accordion__title--animated[aria-expanded='true']:hover .accordion__arrow {
    animation-name: move-up;
    animation-duration: 1.5s;
}
`, "",{"version":3,"sources":["webpack://./src/Common/css/fancy-example.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,aAAa;IACb,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,+BAA+B;AACnC;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,8DAA8D;AAClE;;AAEA,uDAAuD;AACvD,uDAAuD;AACvD,uDAAuD;;AAEvD;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B","sourcesContent":["/**\r\n* ----------------------------------------------\r\n* Demo styles\r\n* ----------------------------------------------\r\n**/\r\n.u-position-absolute {\r\n    position: absolute;\r\n}\r\n\r\n.u-position-relative {\r\n    position: relative;\r\n}\r\n\r\n.accordion {\r\n    border: 1px solid rgba(0, 0, 0, 0.1);\r\n    border-radius: 2px;\r\n}\r\n\r\n.accordion__item + .accordion__item {\r\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.accordion__item--has-icon {\r\n    position: relative;\r\n}\r\n\r\n.accordion__title {\r\n    background-color: #eee;\r\n    color: #444;\r\n    cursor: pointer;\r\n    padding: 18px;\r\n    width: 100%;\r\n    text-align: left;\r\n    border: none;\r\n}\r\n\r\n    .accordion__title:hover {\r\n        background-color: #ddd;\r\n    }\r\n\r\n.accordion__body {\r\n    padding: 20px;\r\n    display: block;\r\n    animation: fadein 0.35s ease-in;\r\n}\r\n\r\n.accordion__body--hidden {\r\n    display: none;\r\n    opacity: 0;\r\n    animation: fadein 0.35s ease-in;\r\n}\r\n\r\n.accordion__title > *:last-child,\r\n.accordion__body > *:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.accordion__arrow {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 24px;\r\n    height: 12px;\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 0;\r\n    margin-top: -6px;\r\n}\r\n\r\n.accordion__arrow::after,\r\n.accordion__arrow::before {\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    width: 10px;\r\n    height: 2px;\r\n    background-color: currentColor;\r\n    content: '';\r\n}\r\n\r\n.accordion__arrow::before {\r\n    left: 4px;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n[aria-expanded='true'] .accordion__arrow::before, [aria-selected='true'] .accordion__arrow::before {\r\n    transform: rotate(-45deg);\r\n}\r\n\r\n.accordion__arrow::after {\r\n    right: 4px;\r\n    transform: rotate(-45deg);\r\n}\r\n\r\n[aria-expanded='true'] .accordion__arrow::after, [aria-selected='true'] .accordion__arrow::after {\r\n    transform: rotate(45deg);\r\n}\r\n\r\n.accordion__arrow::before,\r\n.accordion__arrow::after {\r\n    transition: transform 0.25s ease, -webkit-transform 0.25s ease;\r\n}\r\n\r\n/* -------------------------------------------------- */\r\n/* ---------------- Animation part ------------------ */\r\n/* -------------------------------------------------- */\r\n\r\n@keyframes fadein {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes move-down {\r\n    0% {\r\n        transform: translateY(0);\r\n    }\r\n    10% {\r\n        transform: translateY(0);\r\n    }\r\n    20% {\r\n        transform: translateY(5px);\r\n    }\r\n    30% {\r\n        transform: translateY(0);\r\n    }\r\n    100% {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes move-up {\r\n    0% {\r\n        transform: translateY(0);\r\n    }\r\n    10% {\r\n        transform: translateY(0);\r\n    }\r\n    20% {\r\n        transform: translateY(-5px);\r\n    }\r\n    30% {\r\n        transform: translateY(0);\r\n    }\r\n    100% {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.accordion__title--animated:hover .accordion__arrow {\r\n    animation-name: move-down;\r\n    animation-duration: 1.5s;\r\n}\r\n\r\n.accordion__title--animated[aria-expanded='true']:hover .accordion__arrow {\r\n    animation-name: move-up;\r\n    animation-duration: 1.5s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
